module.exports = __webpack_public_path__ + "img/heart_18.96aeb76d.png";